import * as React from "react";
import Image from "../Image/Image.component";
import { Link } from "react-router-dom";
import { t } from "i18next";
import { UserContext } from "../../contexts/user.context";
import { Icon } from "../input/input.styles";
import DeleteIcon from "../../assets/icons/delete.svg";
import { RiDraggable } from "react-icons/ri";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MdQrCode2, MdMap } from "react-icons/md";
import { useCommanData } from "../../contexts/commanData.context";
import { downloadImage } from "../../utils/fetch.util";

interface Props {
  site: any;
  sectorId: string;
  setToggleViewJobRolesModal: React.Dispatch<any>;
  setIsEditSiteModalOpen: React.Dispatch<any>;
  setSitedId: React.Dispatch<any>;
  setOpenLinkSiteToProviderModel: React.Dispatch<any>;
  setSite: React.Dispatch<any>;
  openSiteConfirmationModal: (sectorId: number, siteId: number) => void;
  setIsQrOpen: React.Dispatch<any>;
  setQrcode: React.Dispatch<any>;
  setQrcodeValue: React.Dispatch<any>;
  setSupervisorModal: React.Dispatch<any>;
  isAdmin: boolean;
  onMapClick?: (site: any) => void;
}

const SingleSite: React.FC<Props> = ({
  site,
  sectorId,
  setToggleViewJobRolesModal,
  openSiteConfirmationModal,
  setIsEditSiteModalOpen,
  setSitedId,
  setQrcode,
  setIsQrOpen,
  setQrcodeValue,
  isAdmin,
  onMapClick,
}) => {
  const { permissions } = React.useContext(UserContext);
  const { API_LINK } = useCommanData();
  const { attributes, setNodeRef, listeners, transform, transition } =
    useSortable({ id: site?.site_id.toString() });

  return (
    <>
      <tr
        id={site?.site_id?.toString()}
        ref={setNodeRef}
        {...attributes}
        style={{
          transition,
          transform: CSS.Transform.toString(transform),
        }}
      >
        <td className="border-2 p-4 py-2">{site.site_serial || "ـــ"}</td>
        <td className="flex items-center border-2 p-4 py-2">
          {site.logo_url && (
            <Image
              className="h-14 mx-auto object-contain w-3/4"
              src={site.logo_url}
              alt="site logo"
            />
          )}
        </td>
        <td className="border-2 p-4 py-2">{site.site_name}</td>
        {!isAdmin && <td className="border-2 p-4 py-2">{site?.points}</td>}
        <td className="border-2 p-4 py-2">
          {site?.qrcode_url && (
            <Image
              onClick={() => {
                if (site.qrcode_url) {
                  setIsQrOpen(true);
                  setQrcode(site.qrcode_url);
                  setQrcodeValue(site?.qrcode);
                }
              }}
              className="h-14 mx-auto object-contain w-3/4 cursor-pointer"
              src={site?.qrcode_url}
              alt="site logo"
            />
          )}
        </td>
        {permissions?.Floors?.read && (
          <td className="border-2 p-4 py-2">
            <Link to={`floors/${site.site_id}`} className="text-primary">
              {t("view")}
            </Link>
          </td>
        )}
        {permissions?.Assets?.read && (
          <td className="border-2 p-4 py-2">
            <Link
              to={`stocking-assets/${site.qrcode}`}
              className="text-primary"
            >
              {t("view")}
            </Link>
          </td>
        )}
        {permissions?.JobRoles?.read && (
          <td className="border-2 p-4 py-2">
            <button
              className="text-primary"
              onClick={() => setToggleViewJobRolesModal(site.site_id)}
            >
              {t("view")}
            </button>
          </td>
        )}
        {/* <td className="border-2 p-4 py-2">
          <button
            className="text-primary"
            onClick={() => setSupervisorModal(site.site_id)}
          >
            {t("view")}
          </button>
        </td> */}
        {(permissions?.Sites?.update || permissions?.Sites?.delete) || isAdmin && (
          <td className="border-2">
            <div className="flex items-center justify-center gap-1">
              {permissions?.Sites?.delete || isAdmin && (
                <button>
                  <Icon
                    src={DeleteIcon}
                    onClick={() =>
                      openSiteConfirmationModal(+sectorId, site.site_id)
                    }
                    style={{ width: 20, height: 20 }}
                    className="inline-block !m-0"
                  />
                </button>
              )}
              {permissions?.Sites?.update || isAdmin && (
                <button>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 inline-block cursor-pointer"
                    onClick={() => {
                      setIsEditSiteModalOpen(true);
                      setSitedId(site.site_id);
                    }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                    />
                  </svg>
                </button>
              )}
              {/* <button
                onClick={() => {
                  setSitedId(site.site_id);
                  setOpenLinkSiteToProviderModel(true);
                  setSite(site);
                }}
              >
                <IoIosLink size={23} />
              </button> */}
              <button
                onClick={() => downloadImage(`${API_LINK}${site?.qrcode_url}`)}
              >
                <MdQrCode2 size={23} />
              </button>
              {onMapClick && (
                <button
                  onClick={() => onMapClick(site)}
                  title="View on Map"
                >
                  <MdMap size={23} />
                </button>
              )}
              {/* <button
                onClick={() => setSiteToChangeConfig(site)}
              >
                <MdOutlineSos size={23} />
              </button> */}
            </div>
          </td>
        )}
        {(permissions?.Sites?.update || permissions?.Sites?.delete) && (
          <td className="border-2 p-4 py-2">
            <div className="flex gap-14 items-center">
              <RiDraggable
                className="text-5xl text-secondary_text hover:text-text duration-200 drag-icon"
                {...listeners}
              />
            </div>
          </td>
        )}
      </tr>
    </>
  );
};

export default SingleSite;
